module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages"
  }, [(_vm.showClose) ? _c('div', {
    staticClass: "messages__close",
    on: {
      "click": _vm.closeEmit
    }
  }) : _vm._e(), _c(_vm.tag, {
    tag: "component",
    class: _vm.classes
  }, [_vm._v(_vm._s(_vm.message))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bef12e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/messages/Messages.vue
// module id = b55d9f94bbb2de513a6e
// module chunks = 0